import { useContext } from 'react';
import { AppNavigatorDelegateContext } from './app-navigator.context';

export const useNavigationActions = () => {
  const appNavigator = useContext(AppNavigatorDelegateContext);
  return {
    navigate: appNavigator.dispatchNavigate,
    open: appNavigator.dispatchOpen,
    back: appNavigator.dispatchBack,
  };
};
